import { render, staticRenderFns } from "./chatLogin.vue?vue&type=template&id=ef8d2476&scoped=true"
import script from "./chatLogin.vue?vue&type=script&lang=js"
export * from "./chatLogin.vue?vue&type=script&lang=js"
import style0 from "./chatLogin.vue?vue&type=style&index=0&id=ef8d2476&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d2476",
  null
  
)

export default component.exports